/**
 * @file The document store singleton on `parameters/analyticsBindings`, the
 * tenant's column-role bindings. Consumer: the Settings → Analytics bindings
 * section, which seeds its draft from it and saves through the
 * `saveAnalyticsConfig` callable. Never write this document through the
 * store's methods: the rules deny every client write, and they would add
 * `modifiedAt`, a key the bindings parser refuses.
 */
import { ANALYTICS_BINDINGS_PATH, type AnalyticsBindings } from '#types';
import { createDocumentStore } from '@/store';

export const analyticsBindingsStore = createDocumentStore<
  Partial<AnalyticsBindings>
>(ANALYTICS_BINDINGS_PATH);
